import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as environmentActions, STATUS } from "reducers/environment";
import { actions as notificationActions } from "reducers/notification";
import * as i18nUtils from "util/i18n";

export const useVerifyPerson = () => {
    const dispatch = useDispatch();
    const [tempBeneficiary, setTempBeneficiary] = useState(null);
    const shareholders = useSelector((state) => state.environment?.shareholdersBeneficiaries);
    const verifyPersonRequest = useSelector((state) => state.environment?.verifyPersonRequest);
    const { status: verifyPersonRequestStatus } = verifyPersonRequest;

    const addFinalBeneficiary = (values) => {
        const temp = Array.from(shareholders);
        temp.push(values);
        dispatch(environmentActions.setShareholdersBeneficiaries(temp));
    };

    const verifyBeneficiary = (values) => {
        const { documentNumber } = values;
        setTempBeneficiary(values);
        /*
            TODOS LOS BENEFICIARIOS DEBEN TENER DNI ARGENTINO
              const { country, documentNumber } = values;
                // Si el pais es Argentina realiza primero la verficacion del beneficiario, sino se agrega directamente
                        if (country === "1") {
                            dispatch(
                                environmentActions.verifyPerson({
                                    documentNumber,
                                    documentType: "CUIL",
                                    personType: "NATURAL_PERSON",
                                }),
                            );
                        } else {
                            addFinalBeneficiary(values);
                        }
        */
        dispatch(
            environmentActions.verifyPerson({
                documentNumber,
                documentType: "CUIL",
                personType: "NATURAL_PERSON",
            }),
        );
    };

    useEffect(() => {
        const { value: verifyPersonRequestValue, id: verifyPersonRequestId } = verifyPersonRequest;
        if (tempBeneficiary !== null && verifyPersonRequestId === tempBeneficiary?.documentNumber) {
            if (verifyPersonRequestStatus === STATUS.SUCCESS && verifyPersonRequestValue) {
                const { listControl, business, disabledBCRA } = verifyPersonRequestValue;
                addFinalBeneficiary({
                    ...tempBeneficiary,
                    listControl,
                    business,
                    disabledBCRA,
                    isFinalBeneficiary: true,
                    addedFromForm: true,
                });
                dispatch(environmentActions.resetVerifyPerson());
            } else if (verifyPersonRequestStatus === STATUS.FAILURE) {
                dispatch(environmentActions.resetVerifyPerson());
                dispatch(
                    notificationActions.showNotification(i18nUtils.get("", "Error. Beneficiario invalido."), "error", [
                        "environment",
                    ]),
                );
            }
        }
    }, [verifyPersonRequest]);

    return { tempBeneficiary, setTempBeneficiary, verifyPersonRequestStatus, verifyBeneficiary };
};

export default useVerifyPerson;
